import React from 'react'
import { Document } from '../landingpage/components/document';
import { Points } from '../landingpage/components/points';

export class Status extends React.Component {
    render() {
        return (
            <>
            <Document>
                <Points>
                    {{ "heading"     : "Technical Milestone completed",
                       "description" : "All major engineering challenges have been successfully resolved, creating a solid foundation and a clear path to commercialization.",
                       "points"  : [
                            {
                                "header"      : "Model Support",
                                "icon"        : "🤖",
                                "description" : "Full fine-tuning capabilities for Llama-3.1-8b and DeepSeek-R1-8b models"
                            },
                                                        {
                                "header"      : "Proof of Concept",
                                "icon"        : "🔬",
                                "description" : "Validated technology with working demonstrations",
                            },
                            {
                                "header"      : "Interactive Playground",
                                "icon"        : "🎮",
                                "description" : "User-friendly interface for testing and demonstrating capabilities",
                            },
                            {
                                "header"      : "Programmatic API",
                                "icon"        : "⚡",
                                "description" : "Complete API for accessing and fine-tuning models programmatically",
                            },
                             {
                                "header"      : "Web Platform",
                                "icon"        : "🌐",
                                "description" : "Professional website and user interface",
                            },
                            {
                                "header"      : "Scaling completed",
                                "icon"        : "📈",
                                "description" : "Successfully transitioned to architecture supporting multiple concurrent users",
                            }
                    ]}}
                </Points>

                <div className="highlight">
                    <h2>Next Milestone</h2>
                    <p>With scaling now completed, the focus has shifted to commercializing the product.</p>
                </div>

                <h2>Why Invest in us?</h2>
                <Points>
                    {{ "points" : [
                        {
                            "icon" : "⏰",
                            "header" : "The Market Timing is Perfect",
                            "description" : "AI adoption is accelerating but failing to deliver ROI. Businesses are desperate for AI that actually works. It's no longer sufficient to just add chatbots every where and build agents that don't work - people are starting to expect more from AI. We're positioned perfectly to meet this growing demand."
                        },
                        {
                            "icon" : "🔄",
                            "header" : "Unique Technology: Continuous Learning While Live",
                            "description" : "Unlike every competitor — OpenAI, Claude, Together AI — our models can learn and improve while staying in production. No downtime, no redeployment. This isn't just an incremental improvement; it's a fundamental rethinking of how AI agents should work."
                        },
                        {
                            "icon" : "🛡️",
                            "header" : "Advanced Safeguards Against Training Risks",
                            "description" : "We've developed a unique technology to mitigate the two biggest problems with continuous learning: Model stability - We've implemented guardrails that keep models stable over time. Anti-overlearning mechanisms - Prevents models from becoming too specialized to recent data."
                        },
                        {
                            "icon" : "✅",
                            "header" : "Proven, Working Technology",
                            "description" : "We're not selling vaporware. All major engineering challenges have been solved: Full fine-tuning for Llama-3.1 and DeepSeek-R1, Working playground and API, Demonstrated proof of concept, 2.5 years of focused development. With the technical risk behind us, we have a clear path to commercialization."
                        },
                        {
                            "icon" : "💰",
                            "header" : "Solving a $40 Billion Problem",
                            "description" : "MIT research shows 95% of organizations get zero ROI on AI investments. We know why: static models that can't adapt. We're not just building a better product—we're solving the core problem that's causing billions in failed AI investments."
                        }
                    ]}}
                </Points>

            </Document>
            </>
        )
    }
}

